import AccessControlService from '../services/accessControl.service';
import http from './client';


async function fetchAccessRulesByCourse(course_id: string | number) {
  const result = await http.get(AccessControlService.API_EP, {
    params: {
      course_id: course_id,
    }
  })
  return result.data.permissions;
}


async function addNote(courseId: string | number, userId: string | number, text: string) {
  const response = await http.post('/api/user/addnote', {text}, {
    params: {
      course_id: courseId,
      user_id: userId
    }
  });

  return response.data;
}

async function updateNote(noteId: string | number, text: string) {
  const response = await http.post('/api/user/updatenote', {text}, {
    params: {
      note_id: noteId,
    }
  });

  return response.data;
}

async function deleteNote(noteId: string | number) {
  const response = await http.post('/api/user/updatenote', null, {
    params: {
      note_id: noteId,
    }
  });

  return response.data;
}

async function getNotes(userId: string | number) {
  const response = await http.get('/api/user/notes', {
    params: {
      user_id: userId
    }
  });
  return response.data;
}
// api/onboarding
// api/onboarding/finish

async function onboardingTasks() {
  const res = await http.get('/api/onboarding');
  return res.data
}

async function onboardingFinish() {
  const res = await http.post('/api/onboarding/finish')
}


async function welcome(data: {clientType: string, contact: string}): Promise<string> {
  const response = await http.post('/api/course/index', data);
  return response.data.redirect_uri;
}

interface IUserBalanceResponse {
  data: {
    balance: number;
    proctoring: number;
    ai: number;
  }
}

async function balance(courseId: string | number) {
  const response = await http.get<IUserBalanceResponse>('/api/v2/user/balance', {
    params: courseId ? { course_id: courseId } : {}
  });

  return response.data.data;
}

const user = {
  fetchAccessRulesByCourse, addNote, updateNote, deleteNote, getNotes, onboardingTasks, onboardingFinish, welcome, balance
}

export default user;